/* eslint-disable no-console, no-case-declarations, no-unused-vars */
import { graphqlClient } from "@/utils/http";
import * as request from "@/data/graphql/courses/course-outline.graphql.js";

export const getCourseOutlines = createServiceFunction(() => request.getCourseOutlines());
export const getCourseOutlineById = createServiceFunction((id) => request.getCourseOutlineById(id));
export const addCourseOutline = createServiceFunction((params) => request.addCourseOutline(params));

export const addCourseOutlineAssessment = createServiceFunction((params) => request.addCourseOutlineAssessment(params));

export const addCourseOutlineUnit = createServiceFunction((params) => request.addCourseOutlineUnit(params));
export const updateCourseOutline = createServiceFunction((params) => request.updateCourseOutline(params));
export const updateCourseOutlineAssessment = createServiceFunction((params) => request.updateCourseOutlineAssessment(params));
export const updateCourseOutlineUnit = createServiceFunction((params) => request.updateCourseOutlineUnit(params));
export const deleteCourseOutlineById = createServiceFunction((id) => request.deleteCourseOutlineById(id));
export const deleteCourseOutlineAssessmentById = createServiceFunction((id) => request.deleteCourseOutlineAssessmentById(id));
export const deleteCourseOutlineUnitById = createServiceFunction((id) => request.deleteCourseOutlineUnitById(id));

function createServiceFunction(fn) {
  return async function (arg) {
    const request = fn(arg);
    return await graphqlClient(request);
  }
}
